import * as angular from 'angular';
import {IController} from "angular";
import {OrderPlanningConfigurationDialogsService} from "../../services/order-planning-configuration-dialogs.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ProcessTrackingStatus} from "../../types/process-tracking-status.enum";
import * as _ from "lodash";

export class CustomOrderPlanningUploadViewComponent implements IController {

  from: number;
  to: number;
  processStatus: string[];
  flowStatuses: string[];
  hasProject: boolean;

  public isConfigurationPanelOpen: boolean = false;
  public filterConfig: any;
  public orderPlanningMonitorRef: any;
  public infiniteScroll: any;
  public loadLimit: number = 20;
  public hasOrderUploadMonitoringPermission: boolean;
  public processStatusOptions: string[] = Object.values(ProcessTrackingStatus);

  constructor(private orderPlanningConfigurationDialogsService: OrderPlanningConfigurationDialogsService, private $infiniteScroll,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $state, private $orderPlanningMonitor, private IAMPermissions) {
  }

  $onInit() {

    this.hasOrderUploadMonitoringPermission = this.IAMPermissions.hasPermission('customOrderPlanning.dashboard.get');

    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDefaultCustomTemplates(),
      range: this.from && this.to ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.today(),
      queryString: undefined,
      bringozFilters: {
        processStatus: this.processStatus,
        flowStatuses: this.flowStatuses,
        hasProject: this.hasProject
      }
    };

    if (this.hasOrderUploadMonitoringPermission) {
      this.orderPlanningMonitorRef = this.$orderPlanningMonitor();

      this.orderPlanningMonitorRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.orderPlanningMonitorRef, this.loadLimit, {getFullData: true});
    }

  }

  onRangeChanged(range) {
    this.filterConfig.range = range;
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});

    this._query();
  }

  onToggleConfigurationPanel() {
    this.isConfigurationPanelOpen = !this.isConfigurationPanelOpen;
  }

  onUpload(event) {
    this.orderPlanningConfigurationDialogsService.uploadOrders(event);
  }

  submitQuery(queryString) {
    this.filterConfig.queryString = queryString;
    this._query();
  }

  onChangeProcessStatus(statuses) {
    this.filterConfig.bringozFilters.processStatus = statuses;
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
    this._query();
  }

  onChangeFlowStatuses(statuses) {
    this.filterConfig.bringozFilters.flowStatuses = statuses;
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});

    this._query();
  }

  onChangeProjectStatus(hasProject) {
    this.filterConfig.bringozFilters.hasProject = hasProject;
    this._query();
  }

  private _query() {
    this.orderPlanningMonitorRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
  }

  private _getQueryParams() {
    return {
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      processStatus: this.filterConfig.bringozFilters.processStatus,
      flowStatuses: this.filterConfig.bringozFilters.flowStatuses,
      hasProject: this.filterConfig.bringozFilters.hasProject
    }
  }

  private _getQueryPayload() {
    return {
      searchTerm: this.filterConfig.queryString,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      processStatus: this.filterConfig.bringozFilters.processStatus,
      flowStatus: this.filterConfig.bringozFilters.flowStatuses,
      hasProject: this.filterConfig.bringozFilters.hasProject,
      limit: this.loadLimit
    };
  }

}

angular
  .module('bringoz.admin.order-planning-configuration')
  .component('customOrderPlanningUploadView', {
    bindings: {
      from: '<',
      to: '<',
      processStatus: '<',
      flowStatuses: '<?',
      hasProject: '<'
    },
    template: require('./custom-order-planning-upload-view.html').default,
    controller: CustomOrderPlanningUploadViewComponent
  });
